import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggler", "menu", "submenuButton"]

  connect() {
    this.highlightActiveLink()
  }

  toggleMenu(event) {
    event.preventDefault()
    this.menuTarget.classList.toggle("open")
  }

  toggleSubmenu(event) {
    event.preventDefault()
    const submenu = event.currentTarget.nextElementSibling
    if (submenu) {
      submenu.classList.toggle("open")
      event.currentTarget.classList.toggle("submenu-opened")
    }
  }

  highlightActiveLink() {
    const path = window.location.pathname
    const activeLink = this.element.querySelector(`.navbar-nav a[href="${path}"]`)
    if (activeLink) {
      activeLink.closest("li").classList.add("active")
    }
  }
}
